import React, { useState, useEffect } from 'react';
import AdminLayout from '../components/AdminLayout';

const API_URL = process.env.REACT_APP_API_URL || '';

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '25px',
    flexWrap: 'wrap',
    gap: '15px'
  },
  button: {
    padding: '12px 24px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    border: 'none'
  },
  primaryButton: {
    background: '#722F37',
    color: 'white'
  },
  secondaryButton: {
    background: '#6c757d',
    color: 'white'
  },
  successButton: {
    background: '#28a745',
    color: 'white'
  },
  dangerButton: {
    background: '#dc3545',
    color: 'white'
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '25px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
    marginBottom: '20px'
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '20px',
    color: '#333'
  },
  templateList: {
    display: 'grid',
    gap: '15px'
  },
  templateCard: {
    border: '2px solid #e0e0e0',
    borderRadius: '10px',
    padding: '20px',
    position: 'relative',
    transition: 'all 0.2s'
  },
  templateCardActive: {
    borderColor: '#28a745',
    background: '#f8fff8'
  },
  templateName: {
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '5px'
  },
  templateMeta: {
    fontSize: '13px',
    color: '#666',
    marginBottom: '10px'
  },
  badge: {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '500'
  },
  badgeActive: {
    background: '#d4edda',
    color: '#155724'
  },
  badgeInactive: {
    background: '#f8f9fa',
    color: '#666'
  },
  templateActions: {
    display: 'flex',
    gap: '10px',
    marginTop: '15px',
    flexWrap: 'wrap'
  },
  smallButton: {
    padding: '6px 12px',
    borderRadius: '5px',
    fontSize: '12px',
    cursor: 'pointer',
    border: '1px solid #ddd',
    background: 'white'
  },
  tabs: {
    display: 'flex',
    gap: '10px',
    marginBottom: '25px',
    flexWrap: 'wrap'
  },
  tab: {
    padding: '10px 20px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    background: 'white',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500'
  },
  tabActive: {
    borderColor: '#722F37',
    background: '#722F37',
    color: 'white'
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px'
  },
  modalContent: {
    background: 'white',
    borderRadius: '12px',
    padding: '30px',
    width: '100%',
    maxWidth: '900px',
    maxHeight: '90vh',
    overflowY: 'auto'
  },
  modalTitle: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '25px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#555'
  },
  input: {
    padding: '12px 14px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none'
  },
  textarea: {
    padding: '12px 14px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    minHeight: '100px',
    resize: 'vertical'
  },
  sectionBox: {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '15px',
    marginBottom: '15px'
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px'
  },
  questionItem: {
    display: 'flex',
    gap: '10px',
    marginBottom: '10px',
    alignItems: 'center'
  },
  questionInput: {
    flex: 1,
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '13px'
  },
  removeBtn: {
    background: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    padding: '8px 12px',
    cursor: 'pointer',
    fontSize: '12px'
  },
  addBtn: {
    background: '#28a745',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    padding: '8px 16px',
    cursor: 'pointer',
    fontSize: '13px'
  },
  modalButtons: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    marginTop: '20px'
  },
  importBox: {
    border: '2px dashed #ddd',
    borderRadius: '10px',
    padding: '30px',
    textAlign: 'center',
    marginBottom: '20px'
  },
  emptyState: {
    textAlign: 'center',
    padding: '40px',
    color: '#888'
  }
};

function AdminTemplates() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEditor, setShowEditor] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [activeTab, setActiveTab] = useState('info');
  const [importData, setImportData] = useState({ nombre: '', year: new Date().getFullYear(), csvData: '' });

  const emptyTemplate = {
    nombre: '',
    descripcion: '',
    year: new Date().getFullYear(),
    departamentos: [],
    dimensiones: [],
    preguntas_abiertas: []
  };

  const fetchTemplates = async () => {
    const token = localStorage.getItem('adminToken');
    const res = await fetch(`${API_URL}/api/admin/templates`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setTemplates(await res.json());
    setLoading(false);
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const handleCreate = () => {
    setEditingTemplate({ ...emptyTemplate });
    setActiveTab('info');
    setShowEditor(true);
  };

  const handleEdit = async (id) => {
    const token = localStorage.getItem('adminToken');
    const res = await fetch(`${API_URL}/api/admin/templates/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setEditingTemplate(await res.json());
    setActiveTab('info');
    setShowEditor(true);
  };

  const handleSave = async () => {
    const token = localStorage.getItem('adminToken');
    const method = editingTemplate.id ? 'PUT' : 'POST';
    const url = editingTemplate.id
      ? `${API_URL}/api/admin/templates/${editingTemplate.id}`
      : `${API_URL}/api/admin/templates`;

    await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(editingTemplate)
    });

    setShowEditor(false);
    fetchTemplates();
  };

  const handleActivate = async (id) => {
    const token = localStorage.getItem('adminToken');
    await fetch(`${API_URL}/api/admin/templates/${id}/activate`, {
      method: 'PUT',
      headers: { Authorization: `Bearer ${token}` }
    });
    fetchTemplates();
  };

  const handleDuplicate = async (id) => {
    const token = localStorage.getItem('adminToken');
    await fetch(`${API_URL}/api/admin/templates/${id}/duplicate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({})
    });
    fetchTemplates();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar esta plantilla?')) return;
    const token = localStorage.getItem('adminToken');
    await fetch(`${API_URL}/api/admin/templates/${id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` }
    });
    fetchTemplates();
  };

  const handleExport = (id) => {
    const token = localStorage.getItem('adminToken');
    window.open(`${API_URL}/api/admin/templates/${id}/export?token=${token}`, '_blank');
  };

  const handleDownloadTemplate = () => {
    const token = localStorage.getItem('adminToken');
    window.open(`${API_URL}/api/admin/templates/download/excel-template?token=${token}`, '_blank');
  };

  const handleImport = async () => {
    const token = localStorage.getItem('adminToken');
    try {
      const res = await fetch(`${API_URL}/api/admin/templates/import`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(importData)
      });
      if (res.ok) {
        setShowImport(false);
        setImportData({ nombre: '', year: new Date().getFullYear(), csvData: '' });
        fetchTemplates();
        alert('Plantilla importada correctamente');
      } else {
        const data = await res.json();
        alert('Error: ' + data.error);
      }
    } catch (err) {
      alert('Error al importar');
    }
  };

  // Funciones para editar dimensiones y preguntas
  const addDepartamento = () => {
    setEditingTemplate({
      ...editingTemplate,
      departamentos: [...editingTemplate.departamentos, '']
    });
  };

  const updateDepartamento = (index, value) => {
    const deps = [...editingTemplate.departamentos];
    deps[index] = value;
    setEditingTemplate({ ...editingTemplate, departamentos: deps });
  };

  const removeDepartamento = (index) => {
    setEditingTemplate({
      ...editingTemplate,
      departamentos: editingTemplate.departamentos.filter((_, i) => i !== index)
    });
  };

  const addDimension = () => {
    setEditingTemplate({
      ...editingTemplate,
      dimensiones: [
        ...editingTemplate.dimensiones,
        {
          id: `dimension_${Date.now()}`,
          nombre: 'Nueva Dimensión',
          orden: editingTemplate.dimensiones.length + 1,
          preguntas: ['']
        }
      ]
    });
  };

  const updateDimension = (index, field, value) => {
    const dims = [...editingTemplate.dimensiones];
    dims[index] = { ...dims[index], [field]: value };
    setEditingTemplate({ ...editingTemplate, dimensiones: dims });
  };

  const removeDimension = (index) => {
    setEditingTemplate({
      ...editingTemplate,
      dimensiones: editingTemplate.dimensiones.filter((_, i) => i !== index)
    });
  };

  const addPreguntaDimension = (dimIndex) => {
    const dims = [...editingTemplate.dimensiones];
    dims[dimIndex].preguntas.push('');
    setEditingTemplate({ ...editingTemplate, dimensiones: dims });
  };

  const updatePreguntaDimension = (dimIndex, pregIndex, value) => {
    const dims = [...editingTemplate.dimensiones];
    dims[dimIndex].preguntas[pregIndex] = value;
    setEditingTemplate({ ...editingTemplate, dimensiones: dims });
  };

  const removePreguntaDimension = (dimIndex, pregIndex) => {
    const dims = [...editingTemplate.dimensiones];
    dims[dimIndex].preguntas = dims[dimIndex].preguntas.filter((_, i) => i !== pregIndex);
    setEditingTemplate({ ...editingTemplate, dimensiones: dims });
  };

  const addSeccionAbierta = () => {
    setEditingTemplate({
      ...editingTemplate,
      preguntas_abiertas: [
        ...editingTemplate.preguntas_abiertas,
        {
          id: `seccion_${Date.now()}`,
          nombre: 'Nueva Sección',
          orden: editingTemplate.preguntas_abiertas.length + 1,
          preguntas: ['']
        }
      ]
    });
  };

  const updateSeccionAbierta = (index, field, value) => {
    const secs = [...editingTemplate.preguntas_abiertas];
    secs[index] = { ...secs[index], [field]: value };
    setEditingTemplate({ ...editingTemplate, preguntas_abiertas: secs });
  };

  const removeSeccionAbierta = (index) => {
    setEditingTemplate({
      ...editingTemplate,
      preguntas_abiertas: editingTemplate.preguntas_abiertas.filter((_, i) => i !== index)
    });
  };

  const addPreguntaAbierta = (secIndex) => {
    const secs = [...editingTemplate.preguntas_abiertas];
    secs[secIndex].preguntas.push('');
    setEditingTemplate({ ...editingTemplate, preguntas_abiertas: secs });
  };

  const updatePreguntaAbierta = (secIndex, pregIndex, value) => {
    const secs = [...editingTemplate.preguntas_abiertas];
    secs[secIndex].preguntas[pregIndex] = value;
    setEditingTemplate({ ...editingTemplate, preguntas_abiertas: secs });
  };

  const removePreguntaAbierta = (secIndex, pregIndex) => {
    const secs = [...editingTemplate.preguntas_abiertas];
    secs[secIndex].preguntas = secs[secIndex].preguntas.filter((_, i) => i !== pregIndex);
    setEditingTemplate({ ...editingTemplate, preguntas_abiertas: secs });
  };

  return (
    <AdminLayout title="Plantillas de Encuesta">
      <div style={styles.header}>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button
            style={{ ...styles.button, ...styles.primaryButton }}
            onClick={handleCreate}
          >
            + Nueva Plantilla
          </button>
          <button
            style={{ ...styles.button, ...styles.secondaryButton }}
            onClick={() => setShowImport(true)}
          >
            Importar CSV
          </button>
          <button
            style={{ ...styles.button, background: '#17a2b8', color: 'white' }}
            onClick={handleDownloadTemplate}
          >
            Descargar Plantilla CSV
          </button>
        </div>
      </div>

      <div style={styles.card}>
        <h3 style={styles.cardTitle}>Plantillas Disponibles</h3>

        {loading ? (
          <div style={styles.emptyState}>Cargando...</div>
        ) : templates.length === 0 ? (
          <div style={styles.emptyState}>No hay plantillas creadas</div>
        ) : (
          <div style={styles.templateList}>
            {templates.map((template) => (
              <div
                key={template.id}
                style={{
                  ...styles.templateCard,
                  ...(template.activa ? styles.templateCardActive : {})
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <div style={styles.templateName}>{template.nombre}</div>
                    <div style={styles.templateMeta}>
                      Año: {template.year} | {template.dimensiones?.length || 0} dimensiones |{' '}
                      {template.departamentos?.length || 0} departamentos
                    </div>
                    {template.descripcion && (
                      <div style={{ fontSize: '13px', color: '#888', marginTop: '5px' }}>
                        {template.descripcion}
                      </div>
                    )}
                  </div>
                  <span style={{
                    ...styles.badge,
                    ...(template.activa ? styles.badgeActive : styles.badgeInactive)
                  }}>
                    {template.activa ? 'Activa' : 'Inactiva'}
                  </span>
                </div>

                <div style={styles.templateActions}>
                  <button style={styles.smallButton} onClick={() => handleEdit(template.id)}>
                    Editar
                  </button>
                  <button style={styles.smallButton} onClick={() => handleDuplicate(template.id)}>
                    Duplicar
                  </button>
                  <button style={styles.smallButton} onClick={() => handleExport(template.id)}>
                    Exportar
                  </button>
                  {!template.activa && (
                    <>
                      <button
                        style={{ ...styles.smallButton, background: '#28a745', color: 'white', border: 'none' }}
                        onClick={() => handleActivate(template.id)}
                      >
                        Activar
                      </button>
                      <button
                        style={{ ...styles.smallButton, background: '#dc3545', color: 'white', border: 'none' }}
                        onClick={() => handleDelete(template.id)}
                      >
                        Eliminar
                      </button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modal Editor */}
      {showEditor && editingTemplate && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <h2 style={styles.modalTitle}>
              {editingTemplate.id ? 'Editar Plantilla' : 'Nueva Plantilla'}
            </h2>

            <div style={styles.tabs}>
              <button
                style={{ ...styles.tab, ...(activeTab === 'info' ? styles.tabActive : {}) }}
                onClick={() => setActiveTab('info')}
              >
                Información
              </button>
              <button
                style={{ ...styles.tab, ...(activeTab === 'departamentos' ? styles.tabActive : {}) }}
                onClick={() => setActiveTab('departamentos')}
              >
                Departamentos
              </button>
              <button
                style={{ ...styles.tab, ...(activeTab === 'dimensiones' ? styles.tabActive : {}) }}
                onClick={() => setActiveTab('dimensiones')}
              >
                Dimensiones (1-5)
              </button>
              <button
                style={{ ...styles.tab, ...(activeTab === 'abiertas' ? styles.tabActive : {}) }}
                onClick={() => setActiveTab('abiertas')}
              >
                Preguntas Abiertas
              </button>
            </div>

            {activeTab === 'info' && (
              <div style={styles.form}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Nombre de la plantilla *</label>
                  <input
                    type="text"
                    style={styles.input}
                    value={editingTemplate.nombre}
                    onChange={(e) => setEditingTemplate({ ...editingTemplate, nombre: e.target.value })}
                  />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Año</label>
                  <input
                    type="number"
                    style={styles.input}
                    value={editingTemplate.year}
                    onChange={(e) => setEditingTemplate({ ...editingTemplate, year: parseInt(e.target.value) })}
                  />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Descripción</label>
                  <textarea
                    style={styles.textarea}
                    value={editingTemplate.descripcion || ''}
                    onChange={(e) => setEditingTemplate({ ...editingTemplate, descripcion: e.target.value })}
                  />
                </div>
              </div>
            )}

            {activeTab === 'departamentos' && (
              <div>
                <p style={{ marginBottom: '15px', color: '#666', fontSize: '14px' }}>
                  Añade los departamentos que aparecerán en la encuesta para empleados.
                </p>
                {editingTemplate.departamentos.map((dep, idx) => (
                  <div key={idx} style={styles.questionItem}>
                    <input
                      type="text"
                      style={styles.questionInput}
                      value={dep}
                      onChange={(e) => updateDepartamento(idx, e.target.value)}
                      placeholder="Nombre del departamento"
                    />
                    <button style={styles.removeBtn} onClick={() => removeDepartamento(idx)}>
                      X
                    </button>
                  </div>
                ))}
                <button style={styles.addBtn} onClick={addDepartamento}>
                  + Añadir Departamento
                </button>
              </div>
            )}

            {activeTab === 'dimensiones' && (
              <div>
                <p style={{ marginBottom: '15px', color: '#666', fontSize: '14px' }}>
                  Dimensiones con preguntas de escala 1-5 (Muy en desacuerdo a Muy de acuerdo).
                </p>
                {editingTemplate.dimensiones.map((dim, dimIdx) => (
                  <div key={dimIdx} style={styles.sectionBox}>
                    <div style={styles.sectionHeader}>
                      <input
                        type="text"
                        style={{ ...styles.input, fontWeight: '600', flex: 1 }}
                        value={dim.nombre}
                        onChange={(e) => updateDimension(dimIdx, 'nombre', e.target.value)}
                        placeholder="Nombre de la dimensión"
                      />
                      <button
                        style={{ ...styles.removeBtn, marginLeft: '10px' }}
                        onClick={() => removeDimension(dimIdx)}
                      >
                        Eliminar Dimensión
                      </button>
                    </div>
                    {dim.preguntas.map((preg, pregIdx) => (
                      <div key={pregIdx} style={styles.questionItem}>
                        <span style={{ color: '#888', width: '30px' }}>{pregIdx + 1}.</span>
                        <input
                          type="text"
                          style={styles.questionInput}
                          value={preg}
                          onChange={(e) => updatePreguntaDimension(dimIdx, pregIdx, e.target.value)}
                          placeholder="Texto de la pregunta"
                        />
                        <button
                          style={styles.removeBtn}
                          onClick={() => removePreguntaDimension(dimIdx, pregIdx)}
                        >
                          X
                        </button>
                      </div>
                    ))}
                    <button
                      style={{ ...styles.addBtn, marginTop: '10px' }}
                      onClick={() => addPreguntaDimension(dimIdx)}
                    >
                      + Añadir Pregunta
                    </button>
                  </div>
                ))}
                <button style={{ ...styles.addBtn, marginTop: '10px' }} onClick={addDimension}>
                  + Añadir Dimensión
                </button>
              </div>
            )}

            {activeTab === 'abiertas' && (
              <div>
                <p style={{ marginBottom: '15px', color: '#666', fontSize: '14px' }}>
                  Secciones con preguntas de respuesta abierta (texto libre).
                </p>
                {editingTemplate.preguntas_abiertas.map((sec, secIdx) => (
                  <div key={secIdx} style={styles.sectionBox}>
                    <div style={styles.sectionHeader}>
                      <input
                        type="text"
                        style={{ ...styles.input, fontWeight: '600', flex: 1 }}
                        value={sec.nombre}
                        onChange={(e) => updateSeccionAbierta(secIdx, 'nombre', e.target.value)}
                        placeholder="Nombre de la sección"
                      />
                      <button
                        style={{ ...styles.removeBtn, marginLeft: '10px' }}
                        onClick={() => removeSeccionAbierta(secIdx)}
                      >
                        Eliminar Sección
                      </button>
                    </div>
                    {sec.preguntas.map((preg, pregIdx) => (
                      <div key={pregIdx} style={styles.questionItem}>
                        <span style={{ color: '#888', width: '30px' }}>{pregIdx + 1}.</span>
                        <input
                          type="text"
                          style={styles.questionInput}
                          value={preg}
                          onChange={(e) => updatePreguntaAbierta(secIdx, pregIdx, e.target.value)}
                          placeholder="Texto de la pregunta"
                        />
                        <button
                          style={styles.removeBtn}
                          onClick={() => removePreguntaAbierta(secIdx, pregIdx)}
                        >
                          X
                        </button>
                      </div>
                    ))}
                    <button
                      style={{ ...styles.addBtn, marginTop: '10px' }}
                      onClick={() => addPreguntaAbierta(secIdx)}
                    >
                      + Añadir Pregunta
                    </button>
                  </div>
                ))}
                <button style={{ ...styles.addBtn, marginTop: '10px' }} onClick={addSeccionAbierta}>
                  + Añadir Sección
                </button>
              </div>
            )}

            <div style={styles.modalButtons}>
              <button
                style={{ ...styles.button, background: '#e0e0e0', color: '#333' }}
                onClick={() => setShowEditor(false)}
              >
                Cancelar
              </button>
              <button
                style={{ ...styles.button, ...styles.primaryButton }}
                onClick={handleSave}
              >
                Guardar Plantilla
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Importar */}
      {showImport && (
        <div style={styles.modal}>
          <div style={{ ...styles.modalContent, maxWidth: '600px' }}>
            <h2 style={styles.modalTitle}>Importar Plantilla desde CSV</h2>

            <div style={styles.form}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Nombre de la plantilla</label>
                <input
                  type="text"
                  style={styles.input}
                  value={importData.nombre}
                  onChange={(e) => setImportData({ ...importData, nombre: e.target.value })}
                  placeholder="Plantilla Importada 2025"
                />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Año</label>
                <input
                  type="number"
                  style={styles.input}
                  value={importData.year}
                  onChange={(e) => setImportData({ ...importData, year: parseInt(e.target.value) })}
                />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Contenido CSV</label>
                <textarea
                  style={{ ...styles.textarea, minHeight: '200px', fontFamily: 'monospace', fontSize: '12px' }}
                  value={importData.csvData}
                  onChange={(e) => setImportData({ ...importData, csvData: e.target.value })}
                  placeholder="Pega aquí el contenido del archivo CSV..."
                />
              </div>

              <div style={{ fontSize: '13px', color: '#666', background: '#f8f9fa', padding: '15px', borderRadius: '8px' }}>
                <strong>Formato esperado:</strong><br />
                TIPO,ID_SECCION,NOMBRE_SECCION,ORDEN,PREGUNTA<br />
                <br />
                Tipos válidos: DEPARTAMENTO, DIMENSION, ABIERTA
              </div>
            </div>

            <div style={styles.modalButtons}>
              <button
                style={{ ...styles.button, background: '#e0e0e0', color: '#333' }}
                onClick={() => setShowImport(false)}
              >
                Cancelar
              </button>
              <button
                style={{ ...styles.button, ...styles.primaryButton }}
                onClick={handleImport}
              >
                Importar
              </button>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}

export default AdminTemplates;
